import { render, staticRenderFns } from "./StclD_Total.vue?vue&type=template&id=0f6ad490"
import script from "./StclD_Total.vue?vue&type=script&lang=js"
export * from "./StclD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports